export const AGENT_RESPONSE_START = 'AGENT_RESPONSE_START';
export const AGENT_RESPONSE_CHUNK = 'AGENT_RESPONSE_CHUNK';
export const AGENT_RESPONSE_END = 'AGENT_RESPONSE_END';
export const AGENT_MESSAGE = 'AGENT_MESSAGE';
export const USER_MESSAGE = 'USER_MESSAGE';
export const TOPIC_SUGGESTIONS = 'TOPIC_SUGGESTIONS';

type TrackParams = {
  event: string;
  properties: Record<string, number | string>;
  context: Record<string, number | string | object>;
  metric: string;
}

export type TrackFunction = (params: TrackParams) => void;

export type ChatAnalytics = {
	origin: string,
	flow_type: string,
	screen: string,
	focus?: string,
}

export type Message = {
	id: string;
	text: string;
	type: string;
};

export type AgentMessage = Message & {
	interactionId?: string;
};

export type UserMessage = Message;

export type ChatResponse = {
	id: string;
	type: string;
};

export type AgentResponseStart = ChatResponse;

export type AgentResponseChunk = ChatResponse & {
	body: string;
};

export type AgentResponseEnd = ChatResponse & {
	interactionId: string;
	data?: ChatResponseData;
};

export type UnknownResponse = ChatResponse;

export type ChatResponseData = {
	type: string;
};

export type TopicSuggestionsData = ChatResponseData & {
	topics: string[];
};

export type UnknownData = ChatResponseData & {
	type: 'UNKNOWN';
};

export function isAgentResponseStart(data: { type: string }): data is AgentResponseStart {
	return !!data && data.type === AGENT_RESPONSE_START;
}

export function isAgentResponseChunk(data: { type: string }): data is AgentResponseChunk {
	return !!data && data.type === AGENT_RESPONSE_CHUNK;
}

export function isAgentResponseEnd(data: { type: string }): data is AgentResponseEnd {
	return !!data && data.type === AGENT_RESPONSE_END;
}

export function isAgentMessage(data: { type: string }): data is AgentMessage {
	return !!data && data.type === AGENT_MESSAGE;
}

export function isUserMessage(data: { type: string }): data is UserMessage {
	return !!data && data.type === USER_MESSAGE;
}

export function isTopicSuggestionsData(data?: {
	type: string;
	topics?: string[];
}): data is TopicSuggestionsData {
	return !!data && data.type === TOPIC_SUGGESTIONS && Array.isArray(data.topics);
}
